import React, {useMemo} from 'react';

import NavBarSuperior from "../NavBarSuperior/NavBarSuperior";
import Header from "../LitAtomicComponents/Header";

import PageCalendar from './components/Calendar';

import * as Styles from './styles';

import {
  SIZE,
} from "../NewSocial/constants";

function Eventos() {
  return (
    <>
      <NavBarSuperior />
      <Styles.Container>
        <Header
          hasActionTop={false}
          textHeader="Calendário de eventos"
          size={SIZE.LARGE}
        />
        <Styles.Content>
          <PageCalendar />
        </Styles.Content>
      </Styles.Container>
    </>
  );
}

export default Eventos;
